"use strict";

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  /**
   * @ngdoc object
   * @name user.controller:UserCtrl
   *
   * @description
   *
   */

  angular.module("users").controller("UserCtrl", UserCtrl);

  function UserCtrl($rootScope, $scope, $timeout, $controller, FormlyService, CustomListsService, UsersService, CustomersService, SyncConfigsService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "UserCtrl";

    vm.oneAtATime = true;

    vm.model = {};

    vm.ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var customerName;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (params.role) {
                vm.model.role = params.role;
              }

              if (!vm.model.positions || vm.model.positions.length === 0) {
                vm.model.positions = ["Conducteur"];
              }
              vm.oldPositions = vm.model.positions;

              if (params.position && !vm.model.positions.includes(params.position)) {
                vm.model.positions = [].concat(_toConsumableArray(vm.model.positions), [params.position]);
              }

              if (!($rootScope.$super == true)) {
                _context.next = 9;
                break;
              }

              _context.next = 7;
              return CustomersService.getNameById(vm.model.customerId);

            case 7:
              customerName = _context.sent;

              vm.displayTitle += " pour " + customerName;

            case 9:
              _context.next = 11;
              return SyncConfigsService.findOne({
                filter: {
                  where: {
                    customerId: $rootScope.$selectedCustomerId.replace("$", "")
                  },
                  fields: { software: true }
                }
              });

            case 11:
              vm.syncConfig = _context.sent;


              vm.previousEmail = vm.model.email;
              vm.previousCellularPhone = vm.model.cellularPhone;
              vm.previousInternalNumber = vm.model.internalNumber;
              vm.previousEndDate = vm.model.endDate;

              vm.previousDefaultManagerId = vm.model.defaultManagerId;
              vm.previousRhManagerId = vm.model.rhManagerId;
              vm.previousQseManagerId = vm.model.qseManagerId;
              vm.previousFleetManagerId = vm.model.fleetManagerId;
              vm.previousOther1ManagerId = vm.model.other1ManagerId;
              vm.previousOther2ManagerId = vm.model.other2ManagerId;

              vm.model.rightsResourceRead = vm.model.rights && vm.model.rights.resource && vm.model.rights.resource.read ? true : false;
              vm.model.rightsResourceWrite = vm.model.rights && vm.model.rights.resource && vm.model.rights.resource.write ? true : false;
              vm.model.rightsResourceDelete = vm.model.rights && vm.model.rights.resource && vm.model.rights.resource.delete ? true : false;

              vm.model.rightsDamageRead = vm.model.rights && vm.model.rights.damage && vm.model.rights.damage.read ? true : false;
              vm.model.rightsDamageWrite = vm.model.rights && vm.model.rights.damage && vm.model.rights.damage.write ? true : false;
              vm.model.rightsDamageSend = vm.model.rights && vm.model.rights.damage && vm.model.rights.damage.send ? true : false;
              vm.model.rightsDamageDelete = vm.model.rights && vm.model.rights.damage && vm.model.rights.damage.delete ? true : false;

              vm.model.rightsDepaRead = vm.model.rights && vm.model.rights.depa && vm.model.rights.depa.read ? true : false;
              vm.model.rightsDepaWrite = vm.model.rights && vm.model.rights.depa && vm.model.rights.depa.write ? true : false;

              vm.model.rightsCourseRead = vm.model.rights && vm.model.rights.course && vm.model.rights.course.read ? true : false;
              vm.model.rightsCourseWrite = vm.model.rights && vm.model.rights.course && vm.model.rights.course.write ? true : false;
              vm.model.rightsCourseDelete = vm.model.rights && vm.model.rights.course && vm.model.rights.course.delete ? true : false;

              vm.userRole = $rootScope.$user.role;

              if (vm.model.typeVehicles && vm.model.typeVehicles.length) {
                if (vm.model.typeVehicles.includes("VLREM")) {
                  vm.model.typeVehicles.splice(vm.model.typeVehicles.indexOf("VLREM"), 1);
                  if (!vm.model.typeVehicles.includes("VUL")) {
                    vm.model.typeVehicles.push("VUL");
                  }
                }
                if (vm.model.typeVehicles.includes("VUREM")) {
                  vm.model.typeVehicles.splice(vm.model.typeVehicles.indexOf("VUREM"), 1);
                  if (!vm.model.typeVehicles.includes("VU")) {
                    vm.model.typeVehicles.push("VU");
                  }
                }
                if (vm.model.typeVehicles.includes("REM")) {
                  vm.model.typeVehicles.splice(vm.model.typeVehicles.indexOf("REM"), 1);
                  if (!vm.model.typeVehicles.includes("PL")) {
                    vm.model.typeVehicles.push("PL");
                  }
                }
              } else {
                vm.model.typeVehicles = [];
              }

              // Types de sinistre pour un opérateur
              if (!vm.model.activatedTypes) {
                vm.model.activatedTypes = [];
              }

              vm.createFields();
              vm.isLoaded = true;

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    // Re-render the form when role is changed
    $scope.$watchGroup(["vm.model.role"], function () {
      if (vm.isLoaded === true && ["super-admin", "user-admin"].includes($rootScope.$user.role)) {
        vm.createFields("security");
      }
    });

    vm.sendLink = function () {
      Notiflix.Confirm.show("Attention", "Voulez-vous vraiment envoyer un lien de connexion au DRM ?", "Oui", "Non", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Notiflix.Loading.standard("Envoi en cours...");
                _context2.prev = 1;
                _context2.next = 4;
                return UsersService.customPut("sendOneDrmLink/" + vm.model._id);

              case 4:
                Notiflix.Notify.success("Email envoyé avec succès.");
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](1);

                Notiflix.Notify.failure("Échec de l'envoi de l'email.");

              case 10:
                Notiflix.Loading.remove();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[1, 7]]);
      })), function () {});
    };

    vm.connectAppAs = function () {
      UsersService.customGet("appLink/" + vm.model._id).then(function (response) {
        $timeout(function () {
          // Copier le texte de la cellule dans le presse-papiers
          navigator.clipboard.writeText(response.shortUrl).then(function () {
            Notiflix.Notify.success("Lien copié dans le presse-papiers !");
          }).catch(function (err) {
            return console.error("Erreur lors de la copie du texte :", err);
          });
        }, 0);
      }).catch(function (error) {
        Notiflix.Notify.failure("Échec de la récupération du lien.");
      });
    };

    vm.connectAs = function () {
      UsersService.customGet("drmLink/" + vm.model._id).then(function (response) {
        $timeout(function () {
          // Copier le texte de la cellule dans le presse-papiers
          navigator.clipboard.writeText(response.url).then(function () {
            Notiflix.Notify.success("Lien copié dans le presse-papiers !");
          }).catch(function (err) {
            return console.error("Erreur lors de la copie du texte :", err);
          });
        }, 0);
      }).catch(function (error) {
        Notiflix.Notify.failure("Échec de la récupération du lien.");
      });
    };

    vm.connectAsBeta = function () {
      UsersService.customGet("drmLink/" + vm.model._id + "?isBeta=true").then(function (response) {
        $timeout(function () {
          // Copier le texte de la cellule dans le presse-papiers
          navigator.clipboard.writeText(response.url).then(function () {
            Notiflix.Notify.success("Lien copié dans le presse-papiers !");
          }).catch(function (err) {
            return console.error("Erreur lors de la copie du texte :", err);
          });
        }, 0);
      }).catch(function (error) {
        Notiflix.Notify.failure("Échec de la récupération du lien.");
      });
    };

    vm.getServiceAccountToken = function () {
      Notiflix.Confirm.show("Attention", "Générer un token API permanent pour ce compte ? Le token précédent restera valide jusqu'à révocation manuelle.", "Générer", "Annuler", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                Notiflix.Loading.standard("Génération en cours...");
                _context3.prev = 1;
                _context3.next = 4;
                return UsersService.post("auth/service-account-token", {
                  userId: vm.model._id
                });

              case 4:
                response = _context3.sent;

                $timeout(function () {
                  navigator.clipboard.writeText(response.token).then(function () {
                    Notiflix.Notify.success("Token API copié dans le presse-papiers !");
                  }).catch(function (err) {
                    return console.error("Erreur lors de la copie du token :", err);
                  });
                }, 0);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                Notiflix.Notify.failure("Échec de la génération du token API.");

              case 11:
                Notiflix.Loading.remove();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[1, 8]]);
      })), function () {});
    };

    vm.check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var allowSave, phone, value, _phone, emailRegex, _value, _value2, _value3, response, responseToCheck;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Pop-up pour alerter les utilisateurs de la suppression de données de collaborateurs inactifs
              if (vm.model.endDate && vm.model.previousEndDate != vm.model.endDate) {
                Notiflix.Notify.info("Vous venez de définir une date de sortie au collaborateur. Une fois cette date dépassée, l'email, les numéros de téléphone et les documents du collaborateur seront supprimés.");
              }

              allowSave = true;


              vm.generateId = function b(a) {
                return a ? (0 | Math.random() * 16).toString(16) : ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/1|0/g, b);
              };

              if (typeof vm.model._id == "undefined") {
                if (typeof vm.model.password1 == "undefined") {
                  vm.model.password = vm.generateId();
                }
              }

              if (!vm.model.cellularPhone) {
                _context4.next = 13;
                break;
              }

              phone = vm.model.cellularPhone.replace(/[\s.\-()]/g, "");

              if (/^00[1-9]\d{6,13}$/.test(phone)) {
                phone = "+" + phone.slice(2);
              } else if (/^0\d{9}$/.test(phone)) {
                phone = "+33" + phone.slice(1);
              }
              if (/^\+[1-9]\d{6,14}$/.test(phone)) {
                vm.model.cellularPhone = phone;
              } else {
                Notiflix.Notify.failure("Le numéro de portable n'est pas valide (format attendu : +33XXXXXXXXX ou 0XXXXXXXXX)");
                allowSave = false;
              }

              if (!(allowSave && vm.model.cellularPhone && vm.model.cellularPhone.length > 0 && vm.model.cellularPhone != vm.previousCellularPhone)) {
                _context4.next = 13;
                break;
              }

              _context4.next = 11;
              return UsersService.customGet("checkIfCellularPhoneExists/" + encodeURIComponent(vm.model.cellularPhone));

            case 11:
              value = _context4.sent;

              if (value >= 1) {
                Notiflix.Notify.failure("Ce portable est déjà associé à un autre collaborateur");
                allowSave = false;
              } else if (value == 0) {
                console.log("cellular phone checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                allowSave = false;
              }

            case 13:

              if (vm.model.phone) {
                _phone = vm.model.phone.replace(/[\s.\-()]/g, "");

                if (/^00[1-9]\d{6,13}$/.test(_phone)) {
                  _phone = "+" + _phone.slice(2);
                } else if (/^0\d{9}$/.test(_phone)) {
                  _phone = "+33" + _phone.slice(1);
                }
                if (/^\+[1-9]\d{6,14}$/.test(_phone)) {
                  vm.model.phone = _phone;
                } else {
                  Notiflix.Notify.failure("Le numéro de téléphone fixe n'est pas valide (format attendu : +33XXXXXXXXX ou 0XXXXXXXXX)");
                  allowSave = false;
                }
              }

              if (typeof vm.model.depaPriority === "number") {
                vm.model.depaPriority = parseInt(vm.model.depaPriority);
              }

              if (!vm.model.firstName && !vm.model.lastName) {
                Notiflix.Notify.failure("Le prénom et le nom ne peuvent être vide.");
                allowSave = false;
              }

              if ((!vm.model.groupsId || vm.model.groupsId.length === 0) && vm.model.isVisibleByEveryone !== true && !vm.model._id // Mandatory only if creation
              ) {
                  Notiflix.Notify.failure("Au moins un groupe doit être associé à ce collaborateur.");
                  allowSave = false;
                }

              if (!vm.model.email && vm.model.positions.length > 0 && vm.model.positions.includes("Manageur") && !vm.model._id // Mandatory only if creation
              ) {
                  Notiflix.Notify.failure("Un email doit être associé à ce collaborateur.");
                  allowSave = false;
                }

              if ((!vm.model.defaultManagerId || vm.model.defaultManagerId.length < 24) && vm.model.positions.length === 1 && vm.model.positions[0] === "Conducteur" && vm.model.isVisibleByEveryone !== true && !vm.model._id // Mandatory only if creation
              ) {
                  Notiflix.Notify.failure("Un manageur doit être associé à ce collaborateur.");
                  allowSave = false;
                }

              if (vm.model.password1 || vm.model.password2) {
                if (!validator.matches(vm.model.password1, /((?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{14,20})/)) {
                  Notiflix.Notify.failure("Le mot de passe doit contenir entre 14 et 20 caractères dont une minuscule, une majuscule, un chiffre et un caractère spécial (@$!%*?&.)");
                  allowSave = false;
                }

                if (vm.model.password1 == vm.model.password2) {
                  vm.model.password = vm.model.password1;
                } else {
                  Notiflix.Notify.failure("Les mots de passe sont différents");
                  allowSave = false;
                }
              }

              if (!vm.model.positions || vm.model.positions.length === 0) {
                vm.model.positions = ["Conducteur"];
              }

              if (!(vm.model.email && vm.model.email.length > 0 && vm.model.email != vm.previousEmail)) {
                _context4.next = 28;
                break;
              }

              emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

              if (!emailRegex.test(vm.model.email)) {
                Notiflix.Notify.failure("La format de l'email n'est pas valide");
                allowSave = false;
              }

              _context4.next = 26;
              return UsersService.customGet("checkIfEmailExists/" + vm.model.email);

            case 26:
              _value = _context4.sent;

              if (_value >= 1) {
                Notiflix.Notify.failure("Cet email est déjà associé à un autre collaborateur");
                allowSave = false;
              } else if (_value == 0) {
                console.log("email checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                allowSave = false;
              }

            case 28:
              if (!(vm.model.internalNumber && vm.model.internalNumber.length > 0 && vm.model.internalNumber != vm.previousInternalNumber)) {
                _context4.next = 33;
                break;
              }

              _context4.next = 31;
              return UsersService.count({
                internalNumber: vm.model.internalNumber,
                customerId: vm.model.customerId
              });

            case 31:
              _value2 = _context4.sent;

              if (_value2 >= 1) {
                Notiflix.Notify.failure("Ce matricule est déjà associé à un autre collaborateur");
                allowSave = false;
              } else if (_value2 == 0) {
                console.log("internal number checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                allowSave = false;
              }

            case 33:
              if (!allowSave) {
                _context4.next = 45;
                break;
              }

              _context4.next = 36;
              return UsersService.customPost("checkIfFirstNameLastNameExists", {
                firstName: vm.model.firstName,
                lastName: vm.model.lastName,
                userId: "$" + vm.model._id, // $undefined if creation
                customerId: vm.model.customerId
              });

            case 36:
              _value3 = _context4.sent;

              if (!(_value3 >= 1)) {
                _context4.next = 44;
                break;
              }

              _context4.next = 40;
              return swal({
                title: "ATTENTION : Un collaborateur avec un nom approchant existe",
                text: "Confirmez-vous l'enregistrement ?",
                icon: "warning",
                dangerMode: true,
                buttons: {
                  cancel: "Non",
                  confirm: "Oui"
                }
              });

            case 40:
              response = _context4.sent;


              if (!response) {
                allowSave = false;
              }
              _context4.next = 45;
              break;

            case 44:
              if (_value3 == 0) {
                console.log("firstName lastName checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                allowSave = false;
              }

            case 45:
              if (!(vm.model.toCheck === true && $rootScope.$user.role !== "user" && allowSave)) {
                _context4.next = 50;
                break;
              }

              _context4.next = 48;
              return swal({
                title: "ATTENTION : Voulez-vous vraiment approuver la fiche de ce collaborateur ?",
                text: "Approuvez-vous cette fiche cr\xE9\xE9e, soit automatiquement suite \xE0 une d\xE9claration de sinistre, soit par un utilisateur ni RH ni Administrateur ?",
                icon: "warning",
                dangerMode: true,
                buttons: {
                  cancel: "Non",
                  confirm: "Oui"
                }
              });

            case 48:
              responseToCheck = _context4.sent;


              if (!responseToCheck) {
                allowSave = false;
              }

            case 50:

              // Clean manager if equals to user
              if (vm.model.defaultManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.defaultManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }
              if (vm.model.rhManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.rhManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }
              if (vm.model.qseManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.qseManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }
              if (vm.model.fleetManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.fleetManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }
              if (vm.model.other1ManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.other1ManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }
              if (vm.model.other2ManagerId === "$" + vm.model._id) {
                Notiflix.Notify.warning("Le " + $rootScope.other2ManagerLabel + " ne peut pas \xEAtre lui-m\xEAme");
                allowSave = false;
              }

              if (vm.model.password1 && allowSave) {
                delete vm.model.password1;
              }

              if (vm.model.password2 && allowSave) {
                delete vm.model.password2;
              }

              if (allowSave) {
                if (!vm.model.rights) {
                  vm.model.rights = {
                    damage: {},
                    depa: {},
                    course: {},
                    resource: {}
                  };
                }

                if (!vm.model.rights.damage) {
                  vm.model.rights.damage = {};
                }
                if (!vm.model.rights.depa) {
                  vm.model.rights.depa = {};
                }
                if (!vm.model.rights.course) {
                  vm.model.rights.course = {};
                }
                if (!vm.model.rights.resource) {
                  vm.model.rights.resource = {};
                }

                if (vm.model.rightsResourceRead === true) {
                  vm.model.rights.resource.read = true;
                } else {
                  vm.model.rights.resource.read = false;
                }
                delete vm.model.rightsResourceRead;

                if (vm.model.rightsResourceWrite === true) {
                  vm.model.rights.resource.write = true;
                } else {
                  vm.model.rights.resource.write = false;
                }
                delete vm.model.rightsResourceWrite;

                if (vm.model.rightsResourceDelete === true) {
                  vm.model.rights.resource.delete = true;
                } else {
                  vm.model.rights.resource.delete = false;
                }
                delete vm.model.rightsResourceDelete;

                if (vm.model.rightsDamageRead === true) {
                  vm.model.rights.damage.read = true;
                } else {
                  vm.model.rights.damage.read = false;
                }
                delete vm.model.rightsDamageRead;

                if (vm.model.rightsDamageWrite === true) {
                  vm.model.rights.damage.write = true;
                } else {
                  vm.model.rights.damage.write = false;
                }
                delete vm.model.rightsDamageWrite;

                if (vm.model.rightsDamageSend) {
                  vm.model.rights.damage.send = true;
                } else {
                  vm.model.rights.damage.send = false;
                }
                delete vm.model.rightsDamageSend;

                if (vm.model.rightsDamageDelete === true) {
                  vm.model.rights.damage.delete = true;
                } else {
                  vm.model.rights.damage.delete = false;
                }
                delete vm.model.rightsDamageDelete;

                if (vm.model.rightsDepaRead === true) {
                  vm.model.rights.depa.read = true;
                } else {
                  vm.model.rights.depa.read = false;
                }
                delete vm.model.rightsDepaRead;

                if (vm.model.rightsDepaWrite === true) {
                  vm.model.rights.depa.write = true;
                } else {
                  vm.model.rights.depa.write = false;
                }
                delete vm.model.rightsDepaWrite;

                if (vm.model.rightsCourseRead === true) {
                  vm.model.rights.course.read = true;
                } else {
                  vm.model.rights.course.read = false;
                }
                delete vm.model.rightsCourseRead;

                if (vm.model.rightsCourseWrite === true) {
                  vm.model.rights.course.write = true;
                } else {
                  vm.model.rights.course.write = false;
                }
                delete vm.model.rightsCourseWrite;

                if (vm.model.rightsCourseDelete === true) {
                  vm.model.rights.course.delete = true;
                } else {
                  vm.model.rights.course.delete = false;
                }
                delete vm.model.rightsCourseDelete;

                if (!vm.model._id && $rootScope.$user.role === "user") {
                  // if new and not hr/admin
                  vm.model.toCheck = true;
                } else if (vm.model.toCheck === true && $rootScope.$user.role !== "user") {
                  vm.model.toCheck = false;
                }

                vm.model.active = !vm.model.endDate || new Date(vm.model.endDate) >= new Date() ? true : false;

                // Désactivation de l'auto-fill si le manager a été modifié manuellement par l'utilisateur (et que ce n'est pas une création d'utilisateur)
                if (vm.model._id && vm.previousDefaultManagerId !== vm.model.defaultManagerId && vm.model.defaultManagerId && vm.model.defaultManagerIdIsAutoFilled !== false) {
                  vm.model.defaultManagerIdIsAutoFilled = false;
                }
                if (vm.model._id && vm.previousRhManagerId !== vm.model.rhManagerId && vm.model.rhManagerId && vm.model.rhManagerIdIsAutoFilled !== false) {
                  vm.model.rhManagerIdIsAutoFilled = false;
                }
                if (vm.model._id && vm.previousQseManagerId !== vm.model.qseManagerId && vm.model.qseManagerId && vm.model.qseManagerIdIsAutoFilled !== false) {
                  vm.model.qseManagerIdIsAutoFilled = false;
                }
                if (vm.model._id && vm.previousFleetManagerId !== vm.model.fleetManagerId && vm.model.fleetManagerId && vm.model.fleetManagerIdIsAutoFilled !== false) {
                  vm.model.fleetManagerIdIsAutoFilled = false;
                }
                if (vm.model._id && vm.previousOther1ManagerId !== vm.model.other1ManagerId && vm.model.other1ManagerId && vm.model.other1ManagerIdIsAutoFilled !== false) {
                  vm.model.other1ManagerIdIsAutoFilled = false;
                }
                if (vm.model._id && vm.previousOther2ManagerId !== vm.model.other2ManagerId && vm.model.other2ManagerId && vm.model.other2ManagerIdIsAutoFilled !== false) {
                  vm.model.other2ManagerIdIsAutoFilled = false;
                }

                if (!vm.isAdmin) {
                  // Prevent non-admin to change role/rights/password
                  delete vm.model.role;
                  delete vm.model.rights;
                  delete vm.model.password;
                }
                if (!vm.isSuperAdmin) {
                  delete vm.model.canLoginToBeta;
                  delete vm.model.isVisibleByEveryone;
                  delete vm.model.isVirtual;
                }
                if (!vm.isSuperAdmin) {
                  delete vm.model.isServiceAccount;
                }
                // TODO: nbElearnings, internalNumber, ... -> DTO côté serveur ?
                vm.save();
              }

            case 59:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    vm.switchTab = function (tab) {
      vm.currentTab = tab;
    };

    vm.createFields = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var previousTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "general";

        var values, fleetManagersList, managersList, rhsList, qseManagersList, other1ManagersList, other2ManagersList, typesVehiclesList, typesOfAccidentList, managerFields, rows, securityRows, roleLine, _roleLine, securityFields;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return localforage.getItem("oneAtATime");

              case 2:
                vm.oneAtATime = _context5.sent;


                vm.currentTab = previousTab;

                _context5.next = 6;
                return Promise.all([UsersService.remoteSelectArray([$rootScope.fleetManagerValue]), // 0
                UsersService.remoteSelectArray([$rootScope.defaultManagerValue]), // 1
                UsersService.remoteSelectArray([$rootScope.rhManagerValue]), // 2
                UsersService.remoteSelectArray([$rootScope.qseManagerValue]), // 3
                UsersService.remoteSelectArray([$rootScope.other1ManagerValue]), // 4
                UsersService.remoteSelectArray([$rootScope.other2ManagerValue]), // 5
                CustomListsService.getSelectArray("typeVehicleV2"), // 6
                CustomListsService.getSelectArray("typeOfAccidentV2")] //7
                );

              case 6:
                values = _context5.sent;
                fleetManagersList = values[0];
                managersList = values[1];
                rhsList = values[2];
                qseManagersList = values[3];
                other1ManagersList = values[4];
                other2ManagersList = values[5];
                typesVehiclesList = values[6].filter(function (item) {
                  return !["VLREM", "VUREM", "REM"].includes(item.value);
                });

                typesVehiclesList = typesVehiclesList.map(function (item) {
                  return { value: item.value, name: item.name.split(" (")[0] };
                });
                typesOfAccidentList = values[7];

                typesOfAccidentList = typesOfAccidentList.map(function (item) {
                  return { value: item.value, name: item.name.split(" (")[0] };
                });

                managerFields = [{
                  key: "defaultManagerId",
                  id: "defaultManagerId",
                  type: "nya-bs-select",
                  className: "col-xs-12 col-sm-12",

                  templateOptions: {
                    label: $rootScope.defaultManagerLabel,
                    options: managersList,
                    addPage: "user",
                    createButton: true,
                    required: !vm.model.defaultManagerId && vm.model.positions.length === 1 && vm.model.positions[0] === "Conducteur" && !vm.model._id ? true : false // Mandatory only if creation
                  },

                  controller: ["$scope", function ($scope) {
                    $controller("SelectUserController", {
                      positions: [$rootScope.defaultManagerValue],
                      $scope: $scope
                    });
                  }]
                }];


                if (!$rootScope.rhManagerHidden) {
                  managerFields.push({
                    key: "rhManagerId",
                    id: "rhManagerId",
                    type: "nya-bs-select",
                    className: "col-xs-12 col-sm-12",

                    templateOptions: {
                      label: $rootScope.rhManagerLabel,
                      options: rhsList,
                      addPage: "user",
                      createButton: true
                    },

                    controller: ["$scope", function ($scope) {
                      $controller("SelectUserController", {
                        positions: [$rootScope.rhManagerValue],
                        $scope: $scope
                      });
                    }]
                  });
                }

                if (!$rootScope.qseManagerHidden) {
                  managerFields.push({
                    key: "qseManagerId",
                    id: "qseManagerId",
                    type: "nya-bs-select",
                    className: "col-xs-12 col-sm-12",

                    templateOptions: {
                      label: $rootScope.qseManagerLabel,
                      options: qseManagersList,
                      //required: true,
                      addPage: "user",
                      createButton: true
                    },

                    controller: ["$scope", function ($scope) {
                      $controller("SelectUserController", {
                        positions: [$rootScope.qseManagerValue],
                        $scope: $scope
                      });
                    }]
                  });
                }

                if (!$rootScope.fleetManagerHidden) {
                  managerFields.push({
                    key: "fleetManagerId",
                    id: "fleetManagerId",
                    type: "nya-bs-select",
                    className: "col-xs-12 col-sm-12",

                    templateOptions: {
                      label: $rootScope.fleetManagerLabel,
                      options: fleetManagersList,
                      //required: true,
                      addPage: "user",
                      createButton: true
                    },

                    controller: ["$scope", function ($scope) {
                      $controller("SelectUserController", {
                        positions: [$rootScope.fleetManagerValue],
                        $scope: $scope
                      });
                    }]
                  });
                }

                if (!$rootScope.other1ManagerHidden) {
                  managerFields.push({
                    key: "other1ManagerId",
                    id: "other1ManagerId",
                    type: "nya-bs-select",
                    className: "col-xs-12 col-sm-12",

                    templateOptions: {
                      label: $rootScope.other1ManagerLabel,
                      options: other1ManagersList,
                      //required: true,
                      addPage: "user",
                      createButton: true
                    },

                    controller: ["$scope", function ($scope) {
                      $controller("SelectUserController", {
                        positions: [$rootScope.other1ManagerValue],
                        $scope: $scope
                      });
                    }]
                  });
                }

                if (!$rootScope.other2ManagerHidden) {
                  managerFields.push({
                    key: "other2ManagerId",
                    id: "other2ManagerId",
                    type: "nya-bs-select",
                    className: "col-xs-12 col-sm-12",

                    templateOptions: {
                      label: $rootScope.other2ManagerLabel,
                      options: other2ManagersList,
                      //required: true,
                      addPage: "user",
                      createButton: true
                    },

                    controller: ["$scope", function ($scope) {
                      $controller("SelectUserController", {
                        positions: [$rootScope.other2ManagerValue],
                        $scope: $scope
                      });
                    }]
                  });
                }

                vm.isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1;
                vm.isSuperAdmin = ["super-admin"].indexOf($rootScope.$user.role) > -1;
                rows = [];

                vm.isSuperLvr = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1;

                _context5.t0 = rows;
                _context5.t1 = {
                  class: "col-xs-12 col-sm-3 col-md-3",
                  boxes: [{
                    mainTitle: "Identification",
                    fields: [FormlyService.text("firstName", "Prénom", true, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.text("lastName", "Nom", true, {
                      className: "col-xs-12 col-sm-12"
                    }), vm.syncConfig ? {
                      template: "<label>ID " + vm.syncConfig.software + " :</label><br/><input value=\"" + (vm.model.internalNumber ? vm.model.internalNumber : "") + "\" class=\"form-control\" disabled/><div style=\"padding-top: 6px;\"/>",
                      className: "col-xs-12 col-sm-12"
                    } : FormlyService.text("internalNumber", "Matricule", false, {
                      className: "col-xs-12 col-sm-12"
                    }), vm.syncConfig ? {
                      template: "<label>Matricule :</label><br/><input value=\"" + (vm.model.trueInternalNumber ? vm.model.trueInternalNumber : "") + "\" class=\"form-control\" disabled/><div style=\"padding-top: 6px;\"/>",
                      className: "col-xs-12 col-sm-12"
                    } : { template: "" }, FormlyService.text("positionTitle", "Titre", false, {
                      className: "col-xs-12 col-sm-12"
                    }), {
                      type: "textarea",
                      key: "note",
                      id: "note",
                      className: "col-xs-12 col-sm-12",
                      templateOptions: {
                        placeholder: "...",
                        label: "Commentaires",
                        rows: 4,
                        cols: 15
                      }
                    }]
                  }, {
                    mainTitle: "Contact",
                    fields: [FormlyService.text("email", "Email (et identifiant de connexion)", vm.model.positions.length > 0 && vm.model.positions.includes("Manageur") && !vm.model._id, // Mandatory only if creation
                    {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.text("cellularPhone", "Portable", false, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.text("phone", "Téléphone fixe", false, {
                      className: "col-xs-12 col-sm-12"
                    })]
                  }]
                };
                _context5.next = 31;
                return UsersService.getPositionArray($rootScope.$selectedCustomerId, true);

              case 31:
                _context5.t2 = _context5.sent;
                _context5.t3 = {
                  label: "Fonctions",
                  placeholder: "Sélectionner une ou plusieurs fonctions",
                  options: _context5.t2,
                  multiple: "multiple"
                };
                _context5.t4 = {
                  type: "nya-bs-select-multiple",
                  key: "positions",
                  id: "positions",
                  className: "col-xs-12 col-sm-12",
                  templateOptions: _context5.t3
                };
                _context5.t5 = FormlyService;
                _context5.next = 37;
                return CustomListsService.getSelectArray("typeContract");

              case 37:
                _context5.t6 = _context5.sent;
                _context5.t7 = {
                  className: "col-xs-12 col-sm-12"
                };
                _context5.t8 = _context5.t5.list.call(_context5.t5, "contract", "Contrat", _context5.t6, false, _context5.t7);
                _context5.t9 = FormlyService.text("externalCompany", "Société d'intérim", false, {
                  className: "col-xs-12 col-sm-12"
                });
                _context5.t10 = {
                  type: "nya-bs-select-multiple",
                  key: "typeVehicles",
                  id: "typeVehicles",
                  className: "col-xs-12 col-sm-12",
                  templateOptions: {
                    label: "Types de véhicules conduits",
                    placeholder: "Sélectionner un ou plusieurs type de véhicules",
                    options: typesVehiclesList,
                    multiple: "multiple"
                  }
                };
                _context5.t11 = FormlyService.text("areaName", "Zone de travail", false, {
                  className: "col-xs-12 col-sm-12"
                });
                _context5.t12 = FormlyService.text("departmentName", "Département", false, {
                  className: "col-xs-12 col-sm-12"
                });
                _context5.t13 = {
                  key: "groupsId",
                  id: "groupsId",
                  type: "select-groups",
                  className: "col-xs-12 col-sm-12",
                  templateOptions: {
                    // Mandatory only if creation
                    label: (!vm.model.groupsId || vm.model.groupsId.length === 0) && !vm.model._id ? "Groupes associés * :" : "Groupes associés :"
                  }
                };
                _context5.t14 = [_context5.t4, _context5.t8, _context5.t9, _context5.t10, _context5.t11, _context5.t12, _context5.t13];
                _context5.t15 = {
                  mainTitle: "Affectation",
                  fields: _context5.t14
                };
                _context5.t16 = [_context5.t15];
                _context5.t17 = {
                  class: "col-xs-12 col-sm-3 col-md-3",
                  boxes: _context5.t16
                };
                _context5.t18 = {
                  class: "col-xs-12 col-sm-3 col-md-3",
                  boxes: [{
                    mainTitle: "Responsables",
                    fields: [].concat(managerFields, [{
                      key: "usersEmailsCcId",
                      id: "usersEmailsCcId",
                      type: "select-users",
                      className: "col-xs-12 col-sm-12",
                      templateOptions: {
                        position: "TousHorsConducteur",
                        label: "Personnes en copie des emails de déclaration de sinistre :"
                      }
                    }])
                  }]
                };
                _context5.t19 = {
                  class: "col-xs-12 col-sm-3 col-md-3",
                  boxes: [{
                    mainTitle: "Dates",
                    fields: [FormlyService.number("yearOfBirth", "Année de naissance", false, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.date("licenceValidityDate", "Date validité permis", false, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.date("startDate", "Date d'embauche", false, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.date("endDate", "Date de sortie", false, {
                      className: "col-xs-12 col-sm-12"
                    }), FormlyService.date("endBlockDate", "Date de fin d'arrêt (congé, maladie, etc.)", false, {
                      className: "col-xs-12 col-sm-12"
                    })]
                  }, {
                    mainTitle: "Documents liés au collaborateur",
                    fields: [FormlyService.doc("docs", "", "user", false, {
                      className: "col-xs-12 col-sm-12"
                    }, "", false)]
                  }]
                };
                _context5.t20 = [_context5.t1, _context5.t17, _context5.t18, _context5.t19];
                _context5.t21 = {
                  columns: _context5.t20
                };

                _context5.t0.push.call(_context5.t0, _context5.t21);

                securityRows = [];

                if (!vm.isAdmin) {
                  _context5.next = 72;
                  break;
                }

                _context5.next = 58;
                return CustomListsService.getSelectArray("roles");

              case 58:
                _context5.t22 = _context5.sent;
                _context5.t23 = {
                  label: "Privilège",
                  options: _context5.t22,
                  required: false
                };
                _context5.t24 = {
                  "templateOptions.disabled": "model.isServiceAccount"
                };
                _context5.t25 = {
                  key: "role",
                  id: "role",
                  className: "col-xs-12 col-sm-12",
                  type: "nya-bs-select",
                  templateOptions: _context5.t23,
                  expressionProperties: _context5.t24
                };
                _context5.t26 = [_context5.t25];
                _context5.t27 = {
                  fieldGroup: _context5.t26
                };
                _context5.t28 = FormlyService.text("password1", "Mot de passe", false, {
                  className: "col-xs-12 col-sm-12"
                });
                _context5.t29 = FormlyService.text("password2", "Contrôle Mot de passe", false, {
                  className: "col-xs-12 col-sm-12"
                });
                roleLine = [_context5.t27, _context5.t28, _context5.t29];


                if (vm.isSuperAdmin) {
                  roleLine.push(FormlyService.bool("canLoginToBeta", "Droits de se connecter à la bêta", false, {
                    className: "col-xs-12 col-sm-12"
                  }));
                }

                securityRows.push({
                  columns: [{
                    class: "col-xs-12 col-sm-3 col-md-4",
                    boxes: []
                  }, {
                    class: "col-xs-12 col-sm-6 col-md-4",
                    boxes: [{
                      mainTitle: "Privilège, droits et mot de passe",
                      fields: [].concat(roleLine)
                    }]
                  }]
                });

                if (vm.model.role && !["super-admin", "super-operator", "operator", "user-admin", "driver"].includes(vm.model.role)) {
                  securityRows.push({
                    columns: [{
                      class: "col-xs-12 col-sm-2 col-md-2",
                      boxes: []
                    }, {
                      class: "col-xs-12 col-sm-2 col-md-2",
                      boxes: [{
                        mainTitle: "Menus Collaborateurs/Véhicules",
                        fields: [FormlyService.bool("rightsResourceRead", "Accès aux menus", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsResourceWrite", "Boutons ''Créer/Modifier''", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsResourceDelete", "Bouton ''Supprimer''", false, { className: "col-xs-12 col-sm-12" })]
                      }]
                    }, {
                      class: "col-xs-12 col-sm-2 col-md-2",
                      boxes: [{
                        mainTitle: "Menu Sinistres",
                        fields: [FormlyService.bool("rightsDamageRead", "Accès au menu", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsDamageWrite", "Boutons ''Créer/Modifier''", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsDamageSend", "Bouton ''Transmettre''", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsDamageDelete", "Bouton ''Supprimer''", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("onlyMerchandise", "Voir uniquement les litiges marchandises", false, {
                          className: "col-xs-12 col-sm-12"
                        })]
                      }]
                    }, {
                      class: "col-xs-12 col-sm-2 col-md-2",
                      boxes: [{
                        mainTitle: "Menu Depa",
                        fields: [FormlyService.bool("rightsDepaRead", "Accès au menu", false, {
                          className: "col-xs-12 col-sm-12"
                        }), { template: "", className: "col-xs-12 col-sm-12" }, FormlyService.bool("rightsDepaWrite", "Boutons ''Gérer le RDV''", false, {
                          className: "col-xs-12 col-sm-12"
                        })]
                      }]
                    }, {
                      class: "col-xs-12 col-sm-2 col-md-2",
                      boxes: [{
                        mainTitle: "Menu Formations",
                        fields: [FormlyService.bool("rightsCourseRead", "Accès au menu", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsCourseWrite", "Boutons ''Créer/Modifier''", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("rightsCourseDelete", "Bouton ''Supprimer''", false, {
                          className: "col-xs-12 col-sm-12"
                        })]
                      }]
                    }]
                  });
                }

                if (vm.isSuperAdmin) {
                  securityRows.push({
                    columns: [{
                      class: "col-xs-12 col-sm-3 col-md-4",
                      boxes: []
                    }, {
                      class: "col-xs-12 col-sm-6 col-md-4",
                      boxes: [{
                        mainTitle: "Autre",
                        fields: [FormlyService.bool("isVirtual", "Ce collaborateur est virtuel (n'existe pas dans le logiciel SIRH/gestion de flotte)", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("isVisibleByEveryone", "Ce conducteur est visible par tout le monde", false, {
                          className: "col-xs-12 col-sm-12"
                        })]
                      }]
                    }]
                  });
                }

                if (vm.isSuperAdmin) {
                  securityRows.push({
                    columns: [{
                      class: "col-xs-12 col-sm-3 col-md-4",
                      boxes: []
                    }, {
                      class: "col-xs-12 col-sm-6 col-md-4",
                      boxes: [{
                        mainTitle: "Intégration API",
                        fields: [Object.assign(FormlyService.bool("isServiceAccount", "Ce compte est un compte de service (accès API sans expiration, ex : Power BI)", false, {
                          className: "col-xs-12 col-sm-12"
                        }), {
                          watcher: {
                            listener: function listener(field, newValue, oldValue, scope) {
                              if (newValue === true) {
                                scope.model.role = null;
                              }
                            }
                          }
                        })]
                      }]
                    }]
                  });
                }

              case 72:

                if (vm.isSuperLvr && vm.model.customerId === "$592e962acef2545fb62f1a99") {
                  vm.operatorRows = [{
                    columns: [{
                      class: "col-xs-12 col-sm-4 col-md-4",
                      boxes: []
                    }, {
                      class: "col-xs-12 col-sm-4 col-md-4",
                      boxes: [{
                        mainTitle: "Conseiller/ère LVR",
                        fields: [{
                          type: "nya-bs-select-multiple",
                          key: "activatedTypes",
                          id: "activatedTypes",
                          className: "col-xs-12 col-sm-12",
                          templateOptions: {
                            label: "Types de sinistre activés (vide = tous)",
                            placeholder: "Sélectionner un ou plusieurs types",
                            options: typesOfAccidentList,
                            multiple: "multiple"
                          }
                        }, FormlyService.number("depaPriority", "Priorité DEPA (valeur élevée = plus prioritaire)", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.time("depaLimitHour", "Heure limite de prise de RDV DEPA", false, {
                          className: "col-xs-12 col-sm-12"
                        }), FormlyService.bool("depaSlidingSlots", "Avec créneaux glissants (1 heure)", false, {
                          className: "col-xs-12 col-sm-12"
                        }), {
                          key: "calendarColor",
                          id: "calendarColor",
                          type: "input",
                          className: "col-xs-12 col-sm-12",
                          templateOptions: {
                            label: "Couleur dans le calendrier"
                          }
                        }, {
                          key: "disabledCustomersId",
                          id: "disabledCustomersId",
                          type: "select-customers",
                          className: "col-xs-12 col-sm-12",
                          templateOptions: {
                            label: "Clients désactivés :"
                          }
                        }]
                      }]
                    }]
                  }];
                }

                if (!vm.isAdmin) {
                  _context5.next = 89;
                  break;
                }

                _context5.next = 76;
                return CustomListsService.getSelectArray("roles");

              case 76:
                _context5.t30 = _context5.sent;
                _context5.t31 = {
                  label: "Privilège",
                  options: _context5.t30,
                  required: false
                };
                _context5.t32 = {
                  "templateOptions.disabled": "model.isServiceAccount"
                };
                _context5.t33 = {
                  key: "role",
                  id: "role",
                  className: "col-xs-12 col-sm-3",
                  type: "nya-bs-select",
                  templateOptions: _context5.t31,
                  expressionProperties: _context5.t32
                };
                _context5.t34 = [_context5.t33];
                _context5.t35 = {
                  fieldGroup: _context5.t34
                };
                _context5.t36 = FormlyService.text("password1", "Mot de passe", false, {
                  className: "col-xs-12 col-sm-3"
                });
                _context5.t37 = FormlyService.text("password2", "Contrôle Mot de passe", false, {
                  className: "col-xs-12 col-sm-3"
                });
                _roleLine = [_context5.t35, _context5.t36, _context5.t37];


                if (vm.isSuperAdmin) {
                  _roleLine.push(FormlyService.bool("canLoginToBeta", "Droits de se connecter à la bêta", false, {
                    className: "col-xs-12 col-sm-3"
                  }));
                }

                securityFields = [FormlyService.line(_roleLine)];

                if (vm.isSuperAdmin) {
                  securityFields.unshift(FormlyService.line([FormlyService.bool("isVirtual", "Ce collaborateur est virtuel (n'existe pas dans le logiciel SIRH/gestion de flotte)", false, {
                    className: "col-xs-12 col-sm-6"
                  }), FormlyService.bool("isVisibleByEveryone", "Ce conducteur est visible par tout le monde", false, {
                    className: "col-xs-12 col-sm-6"
                  })]));
                }

                if (vm.model.customerId !== "$592e962acef2545fb62f1a99") {
                  // LVR
                  securityFields = [].concat(_toConsumableArray(securityFields), [{
                    template: "<b class='text-primary'>Menus Collaborateurs et Véhicules</b><hr/>"
                  }, FormlyService.line([FormlyService.bool("rightsResourceRead", "Accès aux menus", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsResourceWrite", "Boutons ''Créer/Modifier''", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsResourceDelete", "Bouton ''Supprimer''", false, { className: "col-xs-12 col-sm-3" })]), { template: "<b class='text-primary'>Menu Sinistres</b><hr/>" }, FormlyService.line([FormlyService.bool("rightsDamageRead", "Accès au menu", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsDamageWrite", "Boutons ''Créer/Modifier''", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsDamageDelete", "Bouton ''Supprimer''", false, {
                    className: "col-xs-12 col-sm-3"
                  })]), { template: "<b class='text-primary'>Menu Depa</b><hr/>" }, FormlyService.line([FormlyService.bool("rightsDepaRead", "Accès au menu", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsDepaWrite", "Boutons ''Gérer le RDV''", false, {
                    className: "col-xs-12 col-sm-3"
                  })]), { template: "<b class='text-primary'>Menu Formations</b><hr/>" }, FormlyService.line([FormlyService.bool("rightsCourseRead", "Accès au menu", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsCourseWrite", "Boutons ''Créer/Modifier''", false, {
                    className: "col-xs-12 col-sm-3"
                  }), FormlyService.bool("rightsCourseDelete", "Bouton ''Supprimer''", false, {
                    className: "col-xs-12 col-sm-3"
                  })])]);
                }

              case 89:

                vm.rows = rows;

                vm.securityRows = securityRows;

                $timeout(function () {}, 10);

              case 92:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this);
      }));

      return function () {
        return _ref5.apply(this, arguments);
      };
    }();

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: UsersService,
      listPage: "users",
      nameModel: "un collaborateur",
      params: params
    });
  }
})();